export type TableHeadKeys<K extends string> = K;

export type FilterFields<K extends string> = Partial<Record<K, string>>;

export function isFiltering(filterOptions: FilterFields<string>): boolean {
  return Object.values(filterOptions).some(Boolean);
}

export const parseFilterParams = <K extends string>(params: URLSearchParams, headers: TableHeadKeys<K>[]): FilterFields<K> => {
  const filterOptions: FilterFields<K> = {};

  for (const [key, value] of params) {
    if (headers.includes(key as K)) {
      filterOptions[key as K] = value;
    }
  }

  return filterOptions;
};
